import {observer} from "mobx-react";
import {Box, Button, Modal, Typography} from "@mui/material";
import styled from "@emotion/styled";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import CloseIcon from "@mui/icons-material/Close";
import {ButtonPrimary, ButtonPrimaryInvert} from "views/components/buttons/buttons.component";
import React from "react";
import {IModalSaveLocalController} from "views/components/modals/modal_save_local_prediction/modal_save_local_prediction.controller";

const ModalContent = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	gap: 12px;
	outline: none;
	max-width: 600px;
	width: 100%;
	background: #fff;
	padding: 40px 20px;
	border-radius: 24px;
	text-align: center;
	color: #070a0d;
	font-family: var(--fontFamilyBase);

	@media screen and (max-width: 640px) {
		max-width: unset;
		left: 24px;
		right: 24px;
		width: auto;
		transform: translateY(-50%);
	}

	button {
		max-width: 300px;
	}

	h3 {
		color: #070a0d;
		text-align: center;
		font-size: 19px;
		font-style: normal;
		font-weight: 600;
		line-height: 120%; /* 22.8px */
	}

	p {
		padding: 0 24px 12px;
	}

	b {
		font-weight: bold;
	}
`;

const CloseBlock = styled.div`
	width: 40px;
	height: 40px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	position: absolute;
	top: 12px;
	right: 12px;

	button {
		color: #14191f;
		border: 1px solid #14191f;
	}
`;

const ButtonRow = styled(Box)`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 12px;
	width: 100%;
`;

export const ModalSaveLocalPrediction: React.FC = observer(() => {
	const {isOpen, modalContent, i18n, onSave, close} =
		useViewController<IModalSaveLocalController>(Bindings.ModalSaveLocalController);

	return (
		<Modal open={isOpen}>
			<ModalContent>
				<CloseBlock>
					<Button sx={{minWidth: 0}} onClick={close}>
						<CloseIcon />
					</Button>
				</CloseBlock>
				<Typography variant="h3">
					{i18n.t(modalContent?.title ?? "modal.save_local.title", "Are you sure?")}
				</Typography>
				<Typography variant="body1">
					{i18n.t("modal.save_local.message", "lorem ipmus")}
				</Typography>
				<ButtonRow>
					<ButtonPrimary fullWidth variant="contained" onClick={close}>
						{i18n.t("modal.save_local.close", "No, thanks")}
					</ButtonPrimary>
					<ButtonPrimaryInvert onClick={onSave}>
						{i18n.t("modal.save_local.save", "Save")}
					</ButtonPrimaryInvert>
				</ButtonRow>
			</ModalContent>
		</Modal>
	);
});
